import type { ShiftEmployeeLimitKey, ShiftEmployeeLimits, ShiftEmployeeWeeklyCounts, ShiftEmployeeLimitWarning } from 'shared-models';

export const EMPLOYEE_LIMIT_LABELS: Record<ShiftEmployeeLimitKey, string> = {
  minimumWeekdayRequests: 'מינימום בקשות בימי חול',
  minimumWeekendRequests: 'מינימום בקשות בסוף שבוע',
  maximumMorningShifts: 'מקסימום משמרות בוקר',
  maximumEveningShifts: 'מקסימום משמרות ערב',
  maximumTotalShifts: 'מקסימום משמרות בשבוע',
};
export const EMPLOYEE_LIMIT_KEYS = Object.keys(EMPLOYEE_LIMIT_LABELS) as ShiftEmployeeLimitKey[];

export function getEmployeeLimitWarnings(limits: ShiftEmployeeLimits, counts: ShiftEmployeeWeeklyCounts): ShiftEmployeeLimitWarning[] {
  return EMPLOYEE_LIMIT_KEYS.flatMap(key => {
    const limit = limits[key];
    const minimum = key === 'minimumWeekdayRequests' || key === 'minimumWeekendRequests';
    return limit != null && (minimum ? counts[key] < limit : counts[key] > limit)
      ? [{ key, actual: counts[key], limit }] : [];
  });
}